import { Grid } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import "../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import agent from '../../../services/api';
import { UserContext, UserContextPayload } from '../../../context/userContext'
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew, organizationUserDataModel, updateUserOrganizationRolePayload } from '../../../models/axiosModel';
import deleteDoc from "../../../assets/deleteDoc.svg";
import { getBusinessUsername, getChannelIcon, getLinkedChatbotNumbers, formatDateTime } from '../../../utils/constants';
import { primaryColor } from '../../../utils/colors';
import linkedDetailsIcon from '../../../assets/chatbotAssets/linkedDetails.svg'
import GlobalPopUp from '../../utility/globalPopUp';
import AddMember, { addMemberPayload } from './addMember';
import validator from 'validator';
import OrganizationMembers from './organizationMembers';
import OgranizationCard from './organizationCard';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { dashboardBreadcrumb, membersBreadcrumb, workspaceBreadcrumb } from '../../../utils/breadcrumb';
import { getOrganizationNewRole, userDataFromOrganizationDetailResponse, userRolesToHaveAccessToAddMembers } from './organizationConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
interface chatsProps {
    mainSection?: boolean
}
interface integrationRowData {
    id: number,
    iconSrc: string,
    channel_icon: any,
    channel_name: string,
    channel_linked_details: any,
    channel_last_updated_timestamp: string,
}
let initialMemberDetails = {
    private_user_email: "",
    private_user_first_name: "",
    private_user_last_name: "",
    organization_role_id: null,
    private_user_id: null,
    chronox_user_role_id: null,
}
export default function ViewOrganizationDetails(props: chatsProps) {

    const navigate = useNavigate()
    const { setFlagLoading, userDetail, organizationDetails, setOrganizationDetails, GetOrganizationDetails, handleError, onBoardUser, getUserAssignmentRoleApi, userAssignmentRoleData, apiRoutesPermissionAssignment, flagAddMemberPopup, setFlagAddMemberPopup } = useContext(UserContext) as UserContextPayload;
    // const [organizationDetails, setOrganizationDetails] = useState<getOrganizationDetailDataModel | null>(null)
    const [flagDeleteIntegrationDataPopup, setFlagDeleteIntegrationDataPopup] = useState(false)
    const [memberToRemove, setIntegrationSelected] = useState<null | any>(null)
    const [integrationViewData, setIntegrationViewData] = useState<integrationRowData[] | []>([]);
    const { getGlobalIntegrationTypeList, globalIntegrationTypeList, getIntegrationList, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload
    const { breadcrumbs, setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [memberDetails, setMemberDetails] = useState<addMemberPayload>(initialMemberDetails)
    const [flagEditMember, setFlagEditMember] = useState<boolean>(false);
    const [flagInvalidValue, setFlagInvalidValue] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams()
    const organization_id = searchParams.get('organization_id')

    // useEffect(() => {
    //     (async () => {
    //         setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
    //         await getGlobalIntegrationTypeList();
    //         const res = await getIntegrationList();
    //         if (!(res.status)) {
    //             handleError(res);
    //         }
    //         setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    //     })()
    // }, [])


    let headerList = [
        {
            name: "First Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "private_user_first_name",
            // sx: { width: "20px !important", paddingRight: "0px !important" }
        },
        {
            name: "Last Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "private_user_last_name",
        },
        {
            name: "Email",
            alignment: "left",
            flagIcon: false,
            valueKey: "private_user_email",
        },
        {
            name: "Status",
            alignment: "left",
            flagIcon: false,
            flagHtml: true,
            valueKey: "user_organization_status_name",
        },
        {
            name: "Role",
            alignment: "left",
            flagIcon: false,
            valueKey: "user_organization_role_name",
        },

    ]

    useEffect(() => {
        if (integrationListNewStructure !== null && integrationListNewStructure.length > 0) {
            let updatedData = integrationListNewStructure.flatMap((integrationData: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew, index: any) => {
                return {
                    id: integrationData.integrated_channel_id as number,
                    iconSrc: linkedDetailsIcon,
                    channel_icon: <Grid item className={globalStyles.displayFlexStyle}>{getChannelIcon(integrationData.channel_name)}</Grid>,
                    channel_name: getBusinessUsername(integrationData, integrationData.channel_name),
                    channel_linked_details: <span style={{ color: primaryColor }}>{getLinkedChatbotNumbers(integrationData, integrationData.channel_name)}</span>,
                    channel_last_updated_timestamp: formatDateTime("updated_at_timestamp" in integrationData ? integrationData.updated_at_timestamp : integrationData.created_at_timestamp, "dmyTime"),
                };
            });
            setIntegrationViewData(updatedData)
        }
    }, [integrationListNewStructure])

    const [adjustedHeaderList, setAdjustedHeaderList] = useState(headerList);



    const deleteIntegrationDataPopupOpen = (data: any) => {
        setFlagDeleteIntegrationDataPopup(true)
        setIntegrationSelected(data)
    }

    useEffect(() => {
        if (organizationDetails == null) {
            navigate('/')
        }
    }, [searchParams])

    const menuItems = [
        { label: 'Delete', icon: <img src={deleteDoc} alt="delete" width={"16"} height={"16"} />, action: (e: any) => deleteIntegrationDataPopupOpen(e), disabled: (rowDetails: organizationUserDataModel) => userRolesToHaveAccessToAddMembers?.includes(rowDetails.user_organization_role_name?.toLowerCase()) ? true : false },
    ];

    const handleChangeMemberDetails = (value: string | number | null, keyName: string) => {
        setMemberDetails((prevState) => ({ ...prevState, [keyName]: typeof value == 'string' ? value.trim() : value }))
    }
    async function getOrganizationDetails() {
        // const response = await agent.getOrganizationDetails.get();
        // if (response.status) {
        // setOrganizationDetails(response.data[0])
        if (userDetail.user_organization_data && userRolesToHaveAccessToAddMembers?.includes(userDetail.user_organization_data.user_organization_role_name?.toLowerCase())) {
            let editIcon = {
                name: "",
                alignment: "right",
                flagIcon: true,
                valueKey: "",
                iconKey: "editIcon"
            }

            headerList.push(editIcon)
            setAdjustedHeaderList(headerList)
        }
        // } else {

        // }
    }

    const getOrganizationName = () => {
        let organization_name = "Organization Name";
        if (organizationDetails) {
            let obj = organizationDetails?.find((organization) => organization.organization_id === Number(organization_id));
            if (obj) {
                organization_name = obj.organization_name;
            }
        }
        return organization_name;
    }

    const getUserAssignmentRole = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getUserAssignmentRoleApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))    
    }

    useEffect(() => {
        getOrganizationDetails()
        getUserAssignmentRole(); // For Fetching User Assignment Roles (New Roles)

        const updatedBreadcrumb = [
            dashboardBreadcrumb,
            ...((!organization_id && organizationDetails && organizationDetails.length > 1) ? [{ ...workspaceBreadcrumb, isActive: true }] : []),
            ...((organization_id || (organizationDetails && organizationDetails.length === 1)) ? [
                { ...workspaceBreadcrumb, path: (organizationDetails && organizationDetails.length > 1) ? "/organization" : `/organization?organization_id=${organization_id}`, isSamePageRedirecting: true, isActive: false },
                { name: getOrganizationName(), path: (organizationDetails && organizationDetails.length > 1) ? "/organization" : `/organization?organization_id=${organization_id}`, isSamePageRedirecting: true, isActive: false },
                { ...membersBreadcrumb, isActive: true }
            ] : [])
        ];

        setBreadCrumbs(updatedBreadcrumb);

    }, [])


    const handleCancelAddMember = () => {
        setFlagAddMemberPopup(false);
        setMemberDetails(initialMemberDetails);
        setFlagEditMember(false);
    }

    const createUserAssignmentRole = async (user_assignment_id: number, chronox_user_role_id: string) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true, flagFullScreenLoader: true }));
        const payload = {
            user_assignment_id: user_assignment_id,
            chronox_user_role_id: chronox_user_role_id
        }

        const res = await agent.createUserAssignmentRole.post(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            getUserAssignmentRole();
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false, flagFullScreenLoader: false }));
    }

    const updateUserAssignmentRole = async (user_assignment_id: number, chronox_user_role_id: string, user_assignment_role_id: string) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            user_assignment_id: user_assignment_id,
            chronox_user_role_id: chronox_user_role_id,
            user_assignment_role_id: user_assignment_role_id
        }

        const res = await agent.updateUserAssignmentRole.put(payload);
        if(!(res.status)){
            handleError(res);
        } else {
            getUserAssignmentRole()
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const deleteUserAssignmentRole = async (user_assignment_role_id: string) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.deleteUserAssignmentRole.delete(user_assignment_role_id);
        if(!(res.status)){
            handleError(res);
        } else {
            getUserAssignmentRole();
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const handleShareInvitation = async () => {
        if (validator.isEmail(memberDetails.private_user_email.trim())) {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true, flagFullScreenLoader: true }))

            const payload = {
                ...memberDetails,
                user_email: memberDetails?.private_user_email,
            }

            const response = await agent.shareOrganizationInvitation.post(payload);
            if (response.status) {
                const organization_details = await GetOrganizationDetails();
                getOrganizationDetails()
                showSuccess(response.data.message)
                setFlagAddMemberPopup(false); 
                
                const user = userDataFromOrganizationDetailResponse(organization_details?.data?.[0]?.organization_user_data, memberDetails?.private_user_email);
                if(userDetail?.flag_onboarded){ 
                    if(user){
                        onBoardUser(user?.private_user_id);
                    } 
                }
                if(memberDetails?.chronox_user_role_id && user){
                    createUserAssignmentRole(user?.user_assignment_id, memberDetails?.chronox_user_role_id);
                }

                setMemberDetails(initialMemberDetails);
            } else {
                handleError(response);
            }
        } else {
            setFlagInvalidValue(true)
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false, flagFullScreenLoader: false }))

    }

    const updateUserOrganizationRole = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true, flagFullScreenLoader: true }))
        const payload: updateUserOrganizationRolePayload = {
            private_user_id: memberDetails?.private_user_id ?? 0,
            private_user_first_name: memberDetails?.private_user_first_name,
            private_user_last_name: memberDetails?.private_user_last_name,
            user_organization_role_id: memberDetails?.organization_role_id ?? 0,
        }

        const res = await agent.updateUserOrganizationRole.put(payload);
        if (!(res.status)) {
            // handleError(res);
        } else {
            const organization_details = await GetOrganizationDetails();
            getOrganizationDetails()

            const userData = userDataFromOrganizationDetailResponse(organization_details?.data?.[0]?.organization_user_data, memberDetails?.private_user_email)
            const chronoxUserRole = getOrganizationNewRole(userAssignmentRoleData, userData?.user_assignment_id);

            if(userData && chronoxUserRole && chronoxUserRole?.chronox_user_role_id != memberDetails?.chronox_user_role_id){
                if(memberDetails?.chronox_user_role_id){
                    await updateUserAssignmentRole(userData?.user_assignment_id, memberDetails?.chronox_user_role_id, chronoxUserRole?.user_assignment_role_id);
                } else {
                    await deleteUserAssignmentRole(chronoxUserRole?.user_assignment_role_id);
                }
            }
            if(!chronoxUserRole && userData &&  memberDetails?.chronox_user_role_id){
                createUserAssignmentRole(userData?.user_assignment_id, memberDetails?.chronox_user_role_id);
            }
            showSuccess("Member Details Updated Successfully.")
        }
        setFlagAddMemberPopup(false);
        setFlagEditMember(false);
        setMemberDetails(initialMemberDetails);
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false, flagFullScreenLoader: false }))
    }

    return (
        <>
            <Grid item className={`${globalStyles.fullwidth} ${styles.lowerBlock}`}>
                <Grid container direction={"column"}>
                    {/* upper block */}
                    {organizationDetails && organizationDetails.length > 1 && !organization_id &&
                        <Grid item className={styles.upperBlock}>
                            <OgranizationCard organizationDetail={organizationDetails} />
                        </Grid>
                    }
                    {/* lower block */}
                    {((organizationDetails && organizationDetails.length == 1) || organization_id) &&
                        <Grid item xs={12} className={styles.organizationMembersGrid}>
                            <OrganizationMembers
                                setMemberDetails={setMemberDetails}
                                setFlagEditMember={setFlagEditMember}
                                deleteUserAssignmentRole={deleteUserAssignmentRole}
                            />
                        </Grid>
                    }
                </Grid>
            </Grid>
            {flagAddMemberPopup &&
                <GlobalPopUp
                    open={flagAddMemberPopup}
                    titlePadding='0px'
                    flagShowCloseIcon
                    handleClose={() => {
                        setFlagAddMemberPopup(false);
                        setMemberDetails(initialMemberDetails);
                        setFlagInvalidValue(false);
                        setFlagEditMember(false);
                    }}>
                    <AddMember
                        onChangePayload={handleChangeMemberDetails}
                        addMemberPayload={memberDetails}
                        handleShareInvitation={flagEditMember ? updateUserOrganizationRole : handleShareInvitation}
                        cancel={handleCancelAddMember}
                        setFlagKeyExistError={setFlagInvalidValue}
                        flagKeyExistError={flagInvalidValue}
                        flagEditMember={flagEditMember}
                    />
                </GlobalPopUp>
            }
        </>
    )
}
